import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const flag = css`
  width: ${3 * unit}px;
`
